import { Grid }                             from "@gupshup-frontend/gupshup-ts-components";

import Header                               from "./Header";
import Content                              from "./Content";
import ButtonPanel                          from "./ButtonPanel";

import { TEMPLATE_PREVIEW_DATA_TESTID }     from "./constant";
import styles                               from "./style.module.css";

const CarouselCardPanel = (props) => {

  const {
    containerMeta,
    isInPreview         = false,
    isScrollOnHover     = false,
    bypassMediaUrlCheck = false,
    hidePreview         = false,
    // Change #1: forwarded to Header below, same as bypassMediaUrlCheck/hidePreview.
    // Carousel headers go through this component rather than being called directly
    // from WhatsAppPreview.js, so the prop has to be re-threaded here to reach them.
    validateMediaUrl,
  } = props;

  if(!containerMeta?.cards) {
    return <></>;
  }

  return (
    <Grid className = {`${styles.carouselCardPanel} ${isScrollOnHover && styles.scrollOnHover}`} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.CAROUSEL_CARD_PANEL}>
      {containerMeta?.cards?.map((card, index)=> (
        <Grid key = {index} className = {styles.carouselCard} data-testid = {`${TEMPLATE_PREVIEW_DATA_TESTID.CAROUSEL_CARD}-${index}`}>
          <Header
            mediaUrl            = {card.mediaUrl}
            headerType          = {card.headerType}
            containerMeta       = {containerMeta}
            bypassMediaUrlCheck = {bypassMediaUrlCheck}
            hidePreview         = {hidePreview}
            validateMediaUrl    = {validateMediaUrl}
          />
          <Content
            content    = {card.sampleText || card.body}
            dataTestId = {`${TEMPLATE_PREVIEW_DATA_TESTID.CAROUSEL_CARD}-${index}-content`}
          />
          <ButtonPanel
            showAll     = {false}
            buttons     = {card.buttons}
            isInPreview = {isInPreview}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default CarouselCardPanel;
